module.exports = __webpack_public_path__ + "static/media/Instructions_and_User_Journey.8757978b.pdf";